module.exports = __webpack_public_path__ + "static/media/unobtaniums UFO ATTACK.f63a1151.zip";